import { Priority } from "@/types";

/**
 * Returns true if the given user may view/edit this priority. Mirrors the BE gate behind
 * `PRIORITY_CONFIDENTIAL`: leaders and admins see every confidential row, as do its creator and
 * anyone assigned to it.
 */
export function canAccessPriority(priority: Priority, userId?: string, canViewOkr = false): boolean {
  if (!priority.isConfidential) return true;
  if (canViewOkr || priority.isCreator) return true;
  return priority.assignments?.some((a) => a.assignedUser.pid === userId) ?? false;
}
